import { IChannel, IOfflineSchedule, ITrackingLink } from '../../data/api/models';

export interface IBrandingState {
  locale: string;
  i18n: II18nMessages;
  channel: IChannel;
  isOffline: boolean;
  offlineSchedule?: IOfflineSchedule;
  trackingLink?: ITrackingLink;
  aggregatorTracking: IAggregatorTracking;
  defaultChannelKey?: string;
}

export interface IBrandingAction {
  type: string;
  payload?: {
    locale?: string;
    i18n?: II18nMessages;
    channel?: IChannel;
    isOffline?: boolean;
    offlineSchedule?: IOfflineSchedule;
    aggregatorTracking?: IAggregatorTracking;
    trackingLink?: ITrackingLink;
    defaultChannelKey?: string;
  };
}

export interface II18nMessages {
  [messageId: string]: any;
}

export interface IAggregatorTracking {
  type: 'cyti' | 'idol' | null;
  idol?: {
    reference: string;
  };
  cyti?: {
    cref: string;
    url: string;
    token: string;
  };
}


export const OPTION_MAPPING = {
  winter_sports: 'Winter Sports',
  cruise_cover: 'Cruise Cover',
  gadget_cover: 'Gadget Cover',
  excess_waiver: 'Excess Waiver',
  enhanced_trip_disruption: 'Enhanced Trip Disruption Cover'
}

export interface IBrandingActions {
  setLocale(locale: string): IBrandingAction;
  setI18n(i18n: II18nMessages): IBrandingAction;
  setChannel(channel: IChannel): IBrandingAction;
  loadChannel(channelKey: string): Promise<IChannel>;
  reLoadChannel(channelKey: string): Promise<IChannel>;
  getProduct(): any;
  setIsOffline(isOffline: boolean, offlineSchedule: IOfflineSchedule): IBrandingAction;
  setAggregatorTracking(parameters: IAggregatorTracking);
  setTrackingLink(tracking?: any);
  setDefaultChannelKey(channelKey: string);
}
